import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface CancelTestDialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const CancelTestDialog = ({ open, onConfirm, onClose }: CancelTestDialogProps) => {
  const { t } = useTranslation('contentTest');
  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('contentTest.cancelTestDialog.cancelThisTest')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('contentTest.cancelTestDialog.yourTestWillKeepRunning')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('contentTest.cancelTestDialog.keepRunning')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {t('contentTest.cancelTestDialog.cancelTest')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

CancelTestDialog.displayName = 'CancelTestDialog';
